import * as React from "react"
import { Link, router } from "@inertiajs/react"
import { cn } from "@/lib/utils"
import { PageHeader } from "@/components/PageHeader"
import { Select } from "@/components/ui/select"

export type SettingsTabKey =
  | "api"
  | "dropbox"
  | "clip_types"

const TABS: Array<{ key: SettingsTabKey; label: string; href: string }> = [
  { key: "api",        label: "API",        href: "/settings?tab=api" },
  { key: "dropbox",    label: "Dropbox",    href: "/settings?tab=dropbox" },
  { key: "clip_types", label: "Clip types", href: "/settings?tab=clip_types" },
]

export function SettingsLayout({
  activeTab,
  actions,
  children,
}: {
  activeTab: SettingsTabKey
  actions?: React.ReactNode
  children: React.ReactNode
}) {
  return (
    <>
      <PageHeader
        title="Settings"
        description="Tokens, integrations, and the agent behavior knobs that drive Tubery."
        actions={actions}
        tabs={
          <>
            {/* Mobile (< md): full-width dropdown */}
            <div className="border-b border-hairline md:hidden">
              <div className="py-2">
                <Select
                  aria-label="Settings section"
                  value={activeTab}
                  onChange={(e) => {
                    const next = TABS.find((t) => t.key === e.target.value)
                    if (next) router.visit(next.href)
                  }}
                  className="w-full"
                >
                  {TABS.map((tab) => (
                    <option key={tab.key} value={tab.key}>{tab.label}</option>
                  ))}
                </Select>
              </div>
            </div>

            {/* Desktop (md+): horizontal tab strip */}
            <nav className="hidden items-end gap-6 border-b border-hairline md:flex">
              {TABS.map((tab) => {
                const isActive = tab.key === activeTab
                return (
                  <Link
                    key={tab.key}
                    href={tab.href}
                    className={cn(
                      "-mb-px cursor-pointer border-b-2 px-1 py-3 text-sm no-underline",
                      isActive
                        ? "border-accent font-medium text-accent-display"
                        : "border-transparent text-ink-body hover:text-ink-display",
                    )}
                  >
                    {tab.label}
                  </Link>
                )
              })}
            </nav>
          </>
        }
      />
      <div className="mt-6">{children}</div>
    </>
  )
}
